<template>
  <div>
    <CRow>
      <CCol col="3">
        <span>{{ field }}</span>
      </CCol>
      <CCol col="9">
        <div v-if="value !== ''">
          <CImg :src="value" :fluid="true" />
        </div>
        <div v-else>
          <ChooseFile :file-for="fileFor()" :expected-image-height-width="expectedImageHeightWidth" :previous-image="previousImage" @retrieve-file="retrieveData" />
        </div>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import ChooseFile from "./ChooseFile";

export default {
  name: "FormBannerList",
  components: {ChooseFile},
  props: {
    field: {
      type: String,
      default: "implement me"
    },
    value: {
      type: String,
    },
    expectedImageHeightWidth: {
      required: true,
      type: Object,
    },
    previousImage: {
      required: true,
      type: String,
    },
  },
  methods: {
    fileFor() {
      return this.field.replace(/\s+/g, '-').toLowerCase();
    },
    retrieveData(file) {
      this.$emit("retrieve-file", file)
    }
  }
}
</script>
